import { useEffect, useState } from "react";
//--------------------------------------------------------------------------------------------
import { myAxios } from "src/components/common/functions";
import Form from "../form";
export const items = [
    {title: "Date of Incident", type: "date", required: true},
    {title: "Project Name", type:"Select", options: [], required: true}, 
    {title: "Lead On Site", type: "text"},
    {title: "Client Name", type: "text"},
    {title: "Site Contact Name", type: "text"},
    {title: "Site Contact Number", type: "text"},
    {title: "Job Site Address", type: "text"},
    {title: "Incident Information", type: "textarea", required: true},
    {title: "What happened?", type: "textarea", required: true},
    {title: "Will we be going back to fix issue? (explain on No)", type: "radio", onNo: "textarea", required: true},
    {title: "Approver Notes"}
]
//--------------------------------------------------------------------------------------------
export default function IncidentReport({
    closeIt, 
    form, 
    picData, setPicData, 
    sketches, setSketches, 
    usersList, setUserList
}){
    const [projects, setProjects] = useState([]);
    items[1].options = projects.map(project => ({
        value: project.projectName, 
        label: project.projectName
    }));
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const getData = async () => {
            const resProjectNames = await myAxios("common/readProjectNames.php");
            if(!isMounted) return;
            setProjects(resProjectNames.data);
        }
        getData();
        return () => {isMounted = false;}
    },[]);
    //--------------------------------------------------------------------------------------------
    return(
        <Form
            closeIt = {closeIt}
            form = {form}
            picData = {picData}
            setPicData = {setPicData}
            sketches = {sketches}
            setSketches = {setSketches}
            usersList = {usersList}
            setUserList = {setUserList}
            
            items = {items}
            
            picsLimit = {0}
        />
    )    
}